import { useEffect, useState } from "react";
import { formatCountdown } from "./NextPayoutCountdown";

/**
 * Countdown to the next lottery draw (`lottery.nextDrawAt`).
 */
export default function LotteryCountdown({ lottery, compact = false, className = "" }) {
  const targetIso = lottery?.nextDrawAt || null;
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 250);
    return () => clearInterval(id);
  }, []);

  if (!targetIso) {
    if (compact) {
      return (
        <span className={`payout-cd payout-cd--compact ${className}`.trim()}>
          <span className="payout-cd__label">Lottery</span>
          <strong className="payout-cd__clock mono">—</strong>
        </span>
      );
    }
    return null;
  }

  const target = new Date(targetIso).getTime();
  const remaining = target - now;
  const clock = remaining <= 0 ? "soon" : formatCountdown(remaining);
  const minM = lottery?.intervalMin ?? 20;
  const maxM = lottery?.intervalMax ?? 60;

  if (compact) {
    return (
      <span
        className={`payout-cd payout-cd--compact ${className}`.trim()}
        title={`Next draw ${targetIso}`}
      >
        <span className="payout-cd__label">Lottery</span>
        <strong className="payout-cd__clock mono">{clock}</strong>
      </span>
    );
  }

  return (
    <div className={`payout-cd lottery-cd ${className}`.trim()} aria-live="polite">
      <div className="payout-cd__copy">
        <p className="section-kicker" style={{ marginBottom: "0.35rem" }}>
          <i className="brand-diamond" aria-hidden /> Next lottery draw
        </p>
        <strong className="payout-cd__clock mono">{clock}</strong>
        <p className="payout-cd__note">
          Random window every {minM}–{maxM} minutes · equal odds for every eligible holder
        </p>
      </div>
      <div className="payout-cd__meta">
        <span>Draw</span>
        <time dateTime={targetIso}>
          {new Date(target).toLocaleTimeString(undefined, {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            timeZoneName: "short",
          })}
        </time>
      </div>
    </div>
  );
}
